import { useState } from 'react'
import clsx from 'clsx'
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Text,
  Title,
} from 'components/common'

export interface ReservationCardProps {
  title: string
}

export const ReservationCard = ({
  title,
}: ReservationCardProps): JSX.Element => {
  // Reservation details modal state
  const [showReservationModal, setShowReservationModal] = useState(false)

  return (
    <>
      <Card className={clsx('mb-3')}>
        <Space direction="vertical">
          <Title level={5}>{title}</Title>
          <Button
            type={'link'}
            style={{ padding: 0, top: 0 }}
            onClick={() => {
              setShowReservationModal(true)
            }}
          >
            予約詳細を入力してください。
          </Button>
          {/* MOdal Start */}
          <Modal
            title={'予約詳細を編集する'}
            visible={showReservationModal}
            onCancel={() => setShowReservationModal(false)}
            width={700}
            footer={
              <Space>
                <Button
                  key="back"
                  onClick={() => {
                    setShowReservationModal(false)
                  }}
                >
                  キャンセル
                </Button>

                <Button
                  type="primary"
                  onClick={() => {
                    setShowReservationModal(false)
                  }}
                >
                  保存する
                </Button>
              </Space>
            }
          >
            <div>
              <Text>利用内容</Text>
              <Col span={24} className={clsx('mt-8')}>
                <Row gutter={5}>
                  <Col span={12} className={clsx('mb-8')}>
                    <Col span={24} className={clsx('mb-3')}>
                      利用目的
                    </Col>
                    <Col span={24}>
                      <Select
                        placeholder="イベント利用"
                        style={{ width: '100%' }}
                      >
                        <Select.Option value="jack">Jack</Select.Option>
                        <Select.Option value="lucy">Lucy</Select.Option>
                        <Select.Option value="tom">Tom</Select.Option>
                      </Select>
                    </Col>
                  </Col>
                  <Col span={12} className={clsx('mb-8')}>
                    <Col span={24} className={clsx('mb-3')}>
                      利用予定人数
                    </Col>
                    <Col span={24}>
                      <Input />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Space>
                    <Col span={24}>
                      <Col span={24} className={clsx('mb-3')}>
                        物品販売
                      </Col>
                      <Col span={24}>
                        <Checkbox>物品販売を行います</Checkbox>
                      </Col>
                    </Col>
                    <Col span={24}>
                      <Col span={24} className={clsx('mb-3')}>
                        入場料の徴収
                      </Col>
                      <Col span={24}>
                        <Checkbox>入場料の徴収を行います</Checkbox>
                      </Col>
                    </Col>
                  </Space>
                </Row>
              </Col>
            </div>
            <div className={clsx('mt-12')}>
              <Text>利用内容</Text>
              <Col span={24} className={clsx('mt-8')}>
                <Col span={24} className={clsx('mb-8')}>
                  <Col span={24} className={clsx('mb-3')}>
                    利用予定表への掲載
                  </Col>
                  <Checkbox>利用予定表への掲載を行います</Checkbox>
                </Col>
                <Col span={24} className={clsx('mb-8')}>
                  <Col span={24} className={clsx('mb-3')}>
                    利用予定表への掲載可能日
                  </Col>
                  <Col span={24}>
                    <Input style={{ width: '50%' }} />
                  </Col>
                </Col>
                <Col span={24}>
                  <Col span={24} className={clsx('mb-3')}>
                    利用予定表掲載名
                  </Col>
                  <Col span={24}>
                    <Input style={{ width: '100%' }} />
                  </Col>
                </Col>
              </Col>
            </div>
          </Modal>
        </Space>
      </Card>
    </>
  )
}
